<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="卡号："  label-for="key">
              <Input  enter-button placeholder="请输入" v-model="userForm.key" >
              </Input>
            </FormItem>
          </Col>
          <FormItem label="状态："  label-for="key" >
            <Select v-model="userForm.status" style="width:200px;float:left" >
              <Option  value="-1" >全部</Option>
              <Option  value="0" >待发售</Option>
              <Option  value="1" >已发售</Option>
              <Option  value="2" >已作废</Option>
            </Select>
          </FormItem>

          <Col>
            <Button type="primary" shape="circle" icon="ios-search"  @click="userSearchs()">搜索</Button>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="excel()">导出</Button>
          </Col>
        </Row>
      </Form>

      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="status">
          <div v-if="row.status ==0"><Tag  color="success">待发售</Tag ></div>
          <div v-if="row.status ==1"><Tag color="warning">已发售</Tag></div>
          <div v-if="row.status ==2"><Tag color="error">已作废</Tag></div>

        </template>

        <template slot-scope="{ row, index }" slot="action">
          <div v-if="row.status ==0">
          <a @click="edit(row.id)">编辑</a>
          <Divider type="vertical" />
          </div>
          <a @click="del(row.id)">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!--删除-->
    <modalSure ref="modalSure" title="储值卡" :id="banner_id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
    <!--    <modalSure ref="modalSure" title="轮播图" :confirm="confirm" :id="banner_id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>-->
  </div>
</template>

<script>
  import { list, del,excel } from '@/api/stored'
  import { listAll } from '@/api/shop'
  import modalSure from '@/components/modalSure'
  import Setting from '@/setting'
  export default {
    name: 'index',
    components: { modalSure },
    inject: ['reload'],
    data () {
      return {
        userForm: {
          page: 1,
          limit: 10,
          batch_id: 0,
          key: '',
          status:-1,
        },
        modelApi: del,
        banner_id: 0,
        cate_list: [],
        confirm: false,
        dataCount: 0,
        userInfo: [],
        url: Setting.serverSrc,
        loading: false,
        columns2: [
          {
            title: '批次',
            key: 'batch_name',
            minWidth: 120
          },

          {
            title: '卡号',
            key: 'code',
            align: 'center',
            minWidth: 120
          },
          {
            title: '面值',
            key: 'price',
            align: 'center',
            minWidth: 120
          },

          {
            title: '当前状态',
            slot: 'status',
            align: 'center',
            minWidth: 120,

          },

          {
            title: '操作',
            slot: 'action',
            fixed: 'right',
            minWidth: 120
          }
        ]
      }
    },
    created () {
      if (this.$route.params.id) {
        this.userForm.batch_id = this.$route.params.id
      }

      this.articleList ()
      // this.excel()
    },
    activated () {
      this.articleList ()
      this.excel()
    },
    methods: {
      // 表格搜索
      userSearchs () {
        this.userForm.page = 1
        this.articleList()
      },


      articleList  () {
        this.loading = true
        list(this.userForm).then(res => {
          let data = res.data
          this.userInfo = data.list
          this.dataCount = data.count
          this.loading = false
        }).catch(res => {
          this.loading = false
          this.$Message.error(res.msg)
        })
      },
      // 分页
      changepage (status) {
        this.userForm.page = status
        this.articleList()

      },

      edit (id) {
        this.banner_id = id
        this.$router.push({ path: '/admin/stored/stored/edit/' + id })
      },
      add () {
        this.$router.push({ path: '/admin/stored/stored/edit' })
      },
      updateStatusModel (modalStatus) {
        this.reload()
      },
      // 启用禁用用户
      changeSwitch (row) {
        changeUserStatusApi(row.id).then(async res => {
          this.$Message.success(res.msg)
          this.userList()
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      },
      excel(){

        excel(this.userForm).then(res => {
          if(res.code != 200){
            this.$Message.error(res.msg)
          }
          window.open(

            this.url + res.data.url,
            '_self'

          );

        }).catch(res => {
          this.loading = false
          this.$Message.error(res.msg)
        })




      },
      del (row) {

        this.banner_id = row
        // this.confirm = true

        this.$refs.modalSure.isShow = true
      },
      closeModal (val) {
        if (val) {
          this.reload()
        }
      }
    }
  }
</script>
